import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { Modal } from 'app/design-system/components/Modal';

import DocumentModalContent from './components/Content';
import { getPlace } from './utils/get-document-place';

// ---

const DocumentModals: FC = () => {
  const { location: { search }, replace } = useHistory();

  const place = getPlace(search);

  const onClose = useCallback(() => {
    replace({ search: '' });
  }, []);

  if (!place) {
    return null;
  }

  return (
    <Modal isOpen
           onClose={onClose}>
      <DocumentModalContent place={place}
                            onClose={onClose} />
    </Modal>
  );
};

export default DocumentModals;
